'use client';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useLanguage } from '@/utils/LanguageContext';

const CookieConsent = () => {
  const { t, lang } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const consent = localStorage.getItem('cookieConsent');
      if (consent !== 'true') {
        setVisible(true);
      }
    }
  }, []);

  const accept = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('cookieConsent', 'true');
      setVisible(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <p className="cookie-text">
        {t('Cookie Consent Message')}{' '}
        <Link href={`/${lang}/privacy`} prefetch={false} className="cookie-link">
          {t('Privacy Policy')}
        </Link>
      </p>
      <button className="cookie-btn" onClick={accept}>
        {t('Accept')}
      </button>
      <style jsx>{`
        .cookie-consent {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 1rem;
          background: rgba(0, 0, 0, 0.85);
          color: var(--white);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
          z-index: 1000;
        }
        .cookie-btn {
          background: var(--yinmn-blue);
          color: var(--white);
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 4px;
        }
        .cookie-link {
          text-decoration: underline;
        }
        @media (min-width: 640px) {
          .cookie-consent {
            flex-direction: row;
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
